/**
 * Currency Selector Component
 * Dropdown to switch between currencies
 */
import { useCurrency } from '@/context/CurrencyContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { DollarSign } from 'lucide-react';

const CurrencySelector = ({ compact = false, className = '' }) => {
  const { currency, setCurrency, currencies } = useCurrency();

  if (compact) {
    return (
      <Select value={currency} onValueChange={setCurrency}>
        <SelectTrigger className={`w-20 h-8 text-xs ${className}`} data-testid="currency-selector">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(currencies).map(([code, info]) => (
            <SelectItem key={code} value={code} className="text-xs">
              {info.flag} {code}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={`w-[160px] ${className}`} data-testid="currency-selector">
        <DollarSign className="w-4 h-4 mr-1" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(currencies).map(([code, info]) => (
          <SelectItem key={code} value={code}>
            <span className="flex items-center gap-2">
              <span>{info.flag}</span>
              <span>{code}</span>
              <span className="text-muted-foreground text-xs">({info.symbol})</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
